import FullScreenLayout from "../components/layout/FullScreenLayout";
import Login from "../pages/authentication/Login";
import AutoLogin from "../components/hoc/AutoLogin";

export const authRoute = {
    path: "/",
    element: <FullScreenLayout />,
    children: [
        {
            path: "login",
            element: (
                <AutoLogin>
                    <Login />
                </AutoLogin>
            ),
        },
    ],
};
